import rawGetFormattedPrice from '@shared/helpers/rawGetFormattedPrice';
import { Grid, Typography } from '@mui/material';

const Row = ({ children, sx }) => (
  <Typography
    variant="body2"
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      whiteSpace: 'nowrap',
      fontSize: '14px',
      color: '#000',
      ...sx,
    }}
  >
    {children}
  </Typography>
);

const PriceTooltipSummary = ({
  price,
  total_nights,
  total_passangers,
  business_types,
}) => {
  const isB2B = +business_types?.id === 2;
  const amountText = isB2B ? 'Neto total: ' : 'Precio total: ';

  return (
    <Grid
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 0.5,
      }}
    >
      <Row>
        Precio por noche:{' '}
        {rawGetFormattedPrice({
          price,
          business_types,
          showPriceByNight: true,
        })}
      </Row>

      <Row>
        {amountText}
        {rawGetFormattedPrice({
          price,
          business_types,
        })}
      </Row>

      <Row>
        {`${total_nights} ${
          total_nights === 1 ? 'noche' : 'noches'
        }, ${total_passangers} ${
          total_passangers === 1 ? 'huésped' : 'huéspedes'
        }`}
      </Row>
    </Grid>
  );
};

export default PriceTooltipSummary;
